module.exports = __webpack_public_path__ + "static/media/restroom.9cecda26.svg";